import { useGetExecutionFeeUsd } from '@ui/features/Trade/hooks/useGetExecutionFee';
import { usePayTokenPriceLatest } from '@ui/features/Trade/hooks/usePayTokenPriceLatest';
import { Order } from '@ui/hooks/trade/useTradeOrders/types';
import { isNil } from 'lodash-es';
import { useMemo } from 'react';

import { useOrderListContext } from '../context';

export const useLeverage = ({
  order: { collateralToken, getLeverage },
}: {
  order: Order;
}) => {
  const payTokenMarketPrice = usePayTokenPriceLatest(collateralToken);
  const executionFee = useGetExecutionFeeUsd();
  const openFeeP = useOrderListContext().feeConfig?.openFeeP;
  const lvTokenDiscountP = useOrderListContext().feeConfig?.lvTokenDiscountP;

  return useMemo(() => {
    if (isNil(openFeeP) || isNil(lvTokenDiscountP) || isNil(executionFee) || isNil(payTokenMarketPrice))
      return undefined;

    return getLeverage({
      collateralMarketPrice: payTokenMarketPrice,
      executionFee,
      openFeeP,
      lvTokenDiscountP,
    });
  }, [executionFee, getLeverage, lvTokenDiscountP, openFeeP, payTokenMarketPrice]);
};
